import React, { ReactNode } from "react";

import cn from "classnames";
import { defineMessages, useIntl } from "react-intl";

import { LoadingSpinner } from "@mapmycustomers/ui";

import { MAX_ROUTE_STOPS } from "@app/util/consts";

import styles from "./Counter.module.scss";

export const messages = defineMessages({
  ok: {
    id: "activities.calendarView.routeBuilder.footer.counter.description.ok",
    defaultMessage: "Must be fewer than {max}",
    description:
      "Counter description when 0<count<70 in Route Builder's footer in Activity Calendar view",
  },
  setupDisabled: {
    id: "activities.calendarView.routeBuilder.footer.counter.description.setupDisabled",
    defaultMessage:
      "No activities included in selection. Please broaden your selected time range or activity types.",
    description: "Counter description when the Next button is disabled on the Setup step",
  },
});

interface Props {
  comment?: ReactNode;
  count: number;
  loading?: boolean;
  showCount?: boolean;
}

const Counter: React.FC<Props> = ({ comment, count, loading, showCount = true }) => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      {showCount && (
        <div className={styles.counter}>
          {intl.formatMessage(
            {
              id: "activities.calendarView.routeBuilder.footer.counter.title",
              defaultMessage: "Total stops: {count}",
              description: "Counter in Route Builder's footer in Activity Calendar view",
            },
            {
              count: loading ? (
                <LoadingSpinner className={styles.loader} mini />
              ) : (
                <span
                  className={cn(styles.red, {
                    [styles.green]: count > 0 && count <= MAX_ROUTE_STOPS,
                  })}
                >
                  {count}
                </span>
              ),
            }
          )}
        </div>
      )}
      {!showCount && loading && (
        <div className={styles.counter}>
          <LoadingSpinner mini />
        </div>
      )}
      {comment && <div className={styles.description}>{comment}</div>}
    </div>
  );
};

export default Counter;
